import Cookies from "js-cookie";

const isTest =
  location.href.includes("test.angrymiao.com") ||
  !location.href.includes(".angrymiao.com");
const prefix = isTest ? "angrymiao-test-" : "angrymiao-";
const domain =
  window.location.hostname === "localhost" ? "localhost" : "angrymiao.com";

const getItem = (key) => {
  return Cookies.get(key, { domain });
};

const setItem = (key, value, expires) => {
  Cookies.remove(key, { domain });
  return value && Cookies.set(key, value, { expires, domain });
};

function getToken() {
  return getItem(`${prefix}token`) || "";
}

function getRefreshToken() {
  return getItem(`${prefix}refreshToken`) || "";
}

function setToken(token) {
  setItem(`${prefix}token`, token, 1);
}

function setRefreshToken(token) {
  setItem(`${prefix}refreshToken`, token, 30);
}

function signIn({ token, refreshToken }) {
  setToken(token);
  setRefreshToken(refreshToken);
}

function signOut({ token = "", refreshToken = "" } = {}) {
  setToken(token);
  setRefreshToken(refreshToken);
}

function isAuth() {
  return getToken();
}

export default {
  getRefreshToken,
  setRefreshToken,
  getToken,
  setToken,
  signIn,
  signOut,
  isAuth,
};
